export default "__VITE_ASSET__C_el5J9___"